import { render } from "./pharmacy-register.vue?vue&type=template&id=71171304"
import script from "./pharmacy-register.vue?vue&type=script&lang=js"
export * from "./pharmacy-register.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__